import { ChooseLanguageModule } from 'modules';

export const ChooseLanguageScreen = () => {
  return <ChooseLanguageModule />;
};
